import { createContext, useContext } from 'react';
export const WalletMenuContext = createContext({
    isWalletMenuOpen: () => { },
    toggleWalletMenu: () => { },
    openWalletMenu: (_) => { },
    closeWalletMenu: () => { },
});
export const useWalletMenu = () => useContext(WalletMenuContext);
//# sourceMappingURL=WalletMenuContext.js.map